import React from 'react'
import styled from 'styled-components'

import { defaultTheme as theme } from '../../../theme'
import ApolloIcon from '../../../vectors/Apollo'
import ExpressIcon from '../../../vectors/Express'
import GraphQLIcon from '../../../vectors/Graphql'
import HapiIcon from '../../../vectors/Hapi'
import NestJSIcon from '../../../vectors/Nestjs'
import NextJSIcon from '../../../vectors/Nextjs'

const PrismaWithXData = [
  {
    title: 'Next.js',
    text: 'Easiest way to work with a database for this popular React framework.',
    bgColor: '#000',
    icon: <NextJSIcon />,
    to: '/nextjs',
  },
  {
    title: 'GraphQL',
    text: 'Query databases from your GraphQL servers easily with Prisma.',
    bgColor: '#f9c4e7',
    icon: <GraphQLIcon />,
    to: '/graphql',
  },

  {
    title: 'NestJS',
    text: 'Integrate Prisma with this popular server-side application framework.',
    bgColor: '#090909',
    icon: <NestJSIcon />,
    to: '/nestjs',
  },

  {
    title: 'Express',
    text: 'Easy way to query databases in this minimalist web framework.',
    bgColor: '#eee',
    icon: <ExpressIcon />,
    to: '/express',
  },

  {
    title: 'Apollo',
    text: 'Integrate Prisma with one of the most popular GraphQL platforms.',
    bgColor: '#3F20BA',
    icon: <ApolloIcon />,
    to: '/apollo',
  },

  {
    title: 'Hapi',
    text: 'Query databases with ease from this backend framework.',
    bgColor: '#fafafa',
    icon: <HapiIcon />,
    to: '/hapi',
  },
]

const PrismaWithGrid = styled.div`
  background: #ffffff;
  box-shadow: 0px 9px 27px rgba(0, 19, 53, 0.06), 0px 3.75998px 11.28px rgba(0, 19, 53, 0.0431313),
    0px 2.01027px 6.0308px rgba(0, 19, 53, 0.0357664), 0px 1.12694px 3.38082px rgba(0, 19, 53, 0.03),
    0px 0.598509px 1.79553px rgba(0, 19, 53, 0.0242336), 0px 0.249053px 0.747159px rgba(0, 19, 53, 0.0168687);
  border-radius: 10px;
  margin: 0 -128px;
  display: grid;
  text-align: left;
  padding: ${theme.space[32]};
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: ${theme.breakpoints.tabletVertical}px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 16px;
  }
  @media (max-width: ${theme.breakpoints.mobile}px) {
    grid-template-columns: repeat(1, 1fr);
    margin: 0 16px;
  }
`
const PrismaWith = styled.div`
  display: flex;
  padding: ${theme.space[16]};
  border-radius: ${theme.radii.small};
  h4 {
    margin: 0;
    font-size: 24px;
  }
  &:hover {
    background: ${theme.colors.purple[100]};
    h4 {
      color: ${theme.colors.purple[700]};
    }
  }
  p {
    font-size: ${theme.fontSizes[16]};
    color: ${theme.colors.gray[600]};
    line-height: 24px;
  }
  @media (max-width: ${theme.breakpoints.tabletVertical}px) {
    p {
      text-align: left;
    }
  }
`
const PrismaWithThumb = styled.div<{ bg?: string }>`
  width: 56px;
  height: 56px;
  padding: ${theme.space[12]};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${theme.space[24]};
  background: ${p => (p.bg ? p.bg : theme.colors.gray[100])};
  border-radius: ${theme.radii.small};
  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: ${theme.space[40]};
    height: ${theme.space[40]};
    padding: ${theme.space[4]};
  }
`

const PrismaWithX = () => (
  <PrismaWithGrid>
    {PrismaWithXData.map(item => (
      <a href={item.to} target="_blank">
        <PrismaWith>
          <PrismaWithThumb bg={item.bgColor}>{item.icon}</PrismaWithThumb>
          <div>
            <h4>{item.title}</h4>
            <p>{item.text} </p>
          </div>
        </PrismaWith>
      </a>
    ))}
  </PrismaWithGrid>
)

export default PrismaWithX
